import { createSelector } from "@reduxjs/toolkit";
import IBanner from "models/Banner";
import ITimer from "models/Timer";
import { RootState } from "store";
import Reducers from "types/Reducers";

export const selectPages = (state:RootState) => state[Reducers.Pages].pages;
export const selectPageIndex = (state:RootState) => state[Reducers.Pages].pageIndex;

export const selectPage = createSelector(
  [selectPages, selectPageIndex],
  (pages, pageIndex) => {
    return pages[pageIndex];
  }
)

export const selectBanner = createSelector(
  [
    selectPage,
    (state:RootState) => state.quiz.quiz
  ],
  (page, quiz) => quiz.banners?.find((banner:IBanner) => banner.ref === page?.refs[0])
)

export const selectTimer = createSelector(
  [
    selectPage,
    (state:RootState) => state.quiz.quiz
  ],
  (page, quiz) => {
    const timer:ITimer | undefined = quiz.timers?.find((timer:ITimer) => timer.ref === page?.refs[0]);

    return timer;
  }
)